<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  body{
    overflow: hidden;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #ffffff;
    height:100%;
  }
  /*所有margin和padding*/
  .m-t-5{margin-top: 5px};
  .m-r-5{margin-right: 5px};
  .m-b-5{margin-bottom: 5px};
  .m-l-5{margin-left: 5px};

  .m-t-10{margin-top: 10px};
  .m-r-10{margin-right: 10px};
  .m-b-10{margin-bottom: 10px};
  .m-l-10{margin-left: 10px};

  .m-t-20{margin-top: 20px};
  .m-r-20{margin-right: 20px};
  .m-b-20{margin-bottom: 20px};
  .m-l-20{margin-left: 20px};

  .m-t-30{margin-top: 30px};
  .m-r-30{margin-right: 30px};
  .m-b-30{margin-bottom: 30px};
  .m-l-30{margin-left: 30px};

  .p-t-5{padding-top: 5px};
  .p-r-5{padding-right: 5px};
  .p-l-5{padding-left: 5px};
  .p-b-5{padding-bottom: 5px};

  .p-t-10{padding-top: 10px};
  .p-r-10{padding-right: 10px};
  .p-l-10{padding-left: 10px};
  .p-b-10{padding-bottom: 10px};

  .p-t-20{padding-top: 20px};
  .p-r-20{padding-right: 20px};
  .p-l-20{padding-left: 20px};
  .p-b-20{padding-bottom: 20px};

  .item-position{
    position:absolute;
  }
  /*所有的项目标题*/
  .title-item{
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    .first{
      width:3px;
      height:30px;
      background-color: #0fd7ff;
      margin-right: 7px;
    }
    .two{
      font-size: 30px;
      margin-right: 10px;
    }
    .title{
      font-size: 12px;
      div:first-child{
        color:#5f7f9b;
      }
    }
  }
  .alarm{
    color:#d8b419 !important;
  }
  .peccancy{
    color:#fb0505 !important;
  }
  .green{
    color:#1afa29;
  }
  .red{
    color:#fb0505;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue